import { selectContentType } from '#src/lib/contentful/selectors.mjs';
import { mergeStyles } from '#src/hooks/use-merged-styles.js';

import hubCard from '../Ornamentation.hubCard.scss';
import hubCardNoDescription from '../Ornamentation.hubCardNoDescription.scss';

const rowStyles = {
  hubCard: (row) =>
    row?.fields?.image?.fields?.description
      ? hubCard
      : mergeStyles(hubCard, hubCardNoDescription), // we use the absence of an image description to trigger the chat bubble treatment
};

export function getRowStyles(row) {
  const styles = rowStyles[selectContentType(row)];
  return styles?.(row) || {};
}
